<script setup lang="ts">
import { computed } from 'vue';

import { locale } from '@/locale';
import { analytics } from '@/scitylana';

import TruButton from '../TruButton.vue';
import TruCard from '../TruCard.vue';

import HospCertifiedBadge from '@/assets/images/HospCertified_Badge.jpg';
import HospCertifiedBadgeEnCan from '@/assets/images/HospCertified_Badge_EN_CAN.jpg';
import HospCertifiedBadgeFr from '@/assets/images/HospCertified_Badge_FR.jpg';
import HospCertifiedBadgeSp from '@/assets/images/HospCertified_Badge_SP.jpg';
import HospCertifiedLogo from '@/assets/images/HospCertified_logo.png';
import HospCertifiedLogoEnCan from '@/assets/images/HospCertified_logo_EN_CAN.png';
import HospCertifiedLogoFr from '@/assets/images/HospCertified_logo_FR.png';
import HospCertifiedLogoSp from '@/assets/images/HospCertified_logo_SP.png';

const imageBadge = computed(() => {
    switch (locale.value) {
        case 'en-CA':
            return HospCertifiedBadgeEnCan;
        case 'fr-CA':
            return HospCertifiedBadgeFr;
        case 'es-US':
            return HospCertifiedBadgeSp;
        default:
            return HospCertifiedBadge;
    }
});

const imageLogo = computed(() => {
    switch (locale.value) {
        case 'en-CA':
            return HospCertifiedLogoEnCan;
        case 'fr-CA':
            return HospCertifiedLogoFr;
        case 'es-US':
            return HospCertifiedLogoSp;
        default:
            return HospCertifiedLogo;
    }
});

function gotoApplyNow() {
    analytics.home.hospitalCertification();

    // eslint-disable-next-line vue/max-len
    window.open('https://certification.trupanion.com/hospital-signup?utm_campaign=hospital-certification&utm_medium=vet-portal&utm_source=vet&utm_content=apply');
}
</script>

<template>
    <div
        class="hospital-certification"
    >
        <TruCard>
            <div class="hospital-certification-content flex">
                <div class="main-wrapper">
                    <img
                        :alt="$t('dashboard.hospitalCertification.altText')"
                        class="tru-certification-logo"
                        :src="imageLogo"
                    >

                    <div class="certification-desc">
                        <span class="highlight">
                            {{ $t('dashboard.hospitalCertification.highlight') }}&ZeroWidthSpace;
                        </span>

                        <span class="body">
                            {{ $t('dashboard.hospitalCertification.body') }}
                        </span>
                    </div>

                    <TruButton
                        secondary
                        size="xs"
                        @click="gotoApplyNow"
                    >
                        {{ $t('dashboard.hospitalCertification.button') }}
                    </TruButton>
                </div>

                <div class="right flex flex-col justify-center">
                    <img
                        :alt="$t('dashboard.hospitalCertification.badgeAltText')"
                        class="tru-certified-badge"
                        :src="imageBadge"
                    >
                </div>
            </div>
        </TruCard>
    </div>
</template>

<style scoped lang="scss">
@use '../../scss/typography' as *;

.hospital-certification {
    .main-wrapper {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        margin-right: 4rem;

        &>.tru-certification-logo {
            margin-bottom: 3rem;
            width: 25rem;
        }

        .tru-button {
            margin-top: 3rem;
        }
    }

    .certification-desc {
        @extend .desk-body-reg;

        .highlight {
            @extend .desk-body-bold;
        }
    }

    .tru-certified-badge {
        flex-grow: 0;
        flex-shrink: 0;
        height: 20rem;
    }
}
</style>
